export const ADMIN_WORKFLOW_KEYS = Object.freeze({
  MAILJET_EVENT_MIRROR: "mailjet-event-mirror",
  SELF_REGISTRATION_INTAKE: "self-registration-intake",
});

export const ADMIN_WORKFLOW_DEFINITIONS = Object.freeze([
  {
    key: ADMIN_WORKFLOW_KEYS.MAILJET_EVENT_MIRROR,
    titleKey: "admin.workflows.mailjetMirror.title",
    subtitleKey: "admin.workflows.mailjetMirror.subtitle",
    icon: "mdi-email-sync-outline",
    color: "secondary",
    // Instance-based workflow: the list row counts configured instances.
    summaryKind: "instances",
  },
  {
    key: ADMIN_WORKFLOW_KEYS.SELF_REGISTRATION_INTAKE,
    titleKey: "admin.workflows.selfRegistrationIntake.title",
    subtitleKey: "admin.workflows.selfRegistrationIntake.subtitle",
    icon: "mdi-account-arrow-right-outline",
    color: "primary",
    // Singleton workflow: the list row reads the summary block returned by
    // `GET /admin/workflows/instances`.
    summaryKind: "summary",
  },
]);

export const adminWorkflowRouteFor = (workflowKey) => `/admin/workflows/${workflowKey}`;

export const findAdminWorkflowDefinition = (workflowKey) =>
  ADMIN_WORKFLOW_DEFINITIONS.find((definition) => definition.key === workflowKey) || null;
